import React, { useState } from "react";
import "./PricingSlider.css";

const MIN_AMOUNT = 20;
const MAX_AMOUNT = 500;
const STEP_AMOUNT = 5;
const PRICE_PER_SECOND = 0.3;
const AMOUNT_MARKS = [20, 100, 200, 350, 500];

const PricingSlider = () => {
  const [amount, setAmount] = useState(MIN_AMOUNT);
  const seconds = Math.floor(amount / PRICE_PER_SECOND);
  const progress =
    ((amount - MIN_AMOUNT) / (MAX_AMOUNT - MIN_AMOUNT)) * 100;

  return (
    <div className="pricing-slider-container">
      <div className="pricing-selected-package-card">
        <div className="pricing-package-info">
          <div className="pricing-credits-display">
            <span className="pricing-credits-number">${amount}</span>
            <span className="pricing-credits-text">Wallet Top-Up</span>
          </div>
          <div className="pricing-price-display">
            <div className="pricing-savings-badge">
              <i className="feather-zap"></i>
              Pay as you go
            </div>
            <span className="pricing-current-price">$0.30/sec</span>
          </div>
        </div>

        <div className="pricing-slider-wrapper">
          <div className="pricing-slider-meta">
            <span>Choose your starting balance</span>
            <strong>${amount.toLocaleString()}</strong>
          </div>
          <input
            className="pricing-range-slider"
            type="range"
            min={MIN_AMOUNT}
            max={MAX_AMOUNT}
            step={STEP_AMOUNT}
            value={amount}
            style={{ "--pricing-progress": `${progress}%` }}
            aria-label="Wallet top-up amount"
            onChange={(event) => setAmount(Number(event.target.value))}
          />
          <div className="pricing-slider-marks">
            {AMOUNT_MARKS.map((mark) => (
              <button
                className={amount >= mark ? "active" : ""}
                key={mark}
                type="button"
                onClick={() => setAmount(mark)}
              >
                ${mark}
              </button>
            ))}
          </div>
        </div>

        <div className="pricing-package-details">
          <div className="pricing-detail-item">
            <span className="pricing-label">Minimum top-up:</span>
            <span className="pricing-value">$20</span>
          </div>
          <div className="pricing-detail-item">
            <span className="pricing-label">Estimated video seconds:</span>
            <span className="pricing-value pricing-highlight">
              {seconds.toLocaleString()} seconds
            </span>
          </div>
          <div className="pricing-detail-item">
            <span className="pricing-label">Unused balance:</span>
            <span className="pricing-value">Stays in your wallet</span>
          </div>
        </div>

        <div className="pricing-cta-wrapper button-group">
          <a
            className="btn-default btn-large bg-light-gradient w-100"
            href="/employers/sign-up"
          >
            <div className="has-bg-light"></div>
            <span>Start with ${amount}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PricingSlider;
